

export class RouterParams {
  
  static PROPERTY_TYPE = 'type';
  static PROPERTY_SESSION = 'session';
  static PROPERTY_TOKEN = 'token';
  static PROPERTY_2BAP_EXTERNAL_TOKEN = '_2bap_external_token';
  static PROPERTY_RETURN_URL = 'returnUrl';
  
  get type() {
    return this._getUrlParameterByName(RouterParams.PROPERTY_TYPE);
  }
  
  get session() {
    return this._getUrlParameterByName(RouterParams.PROPERTY_SESSION);
  }
  
  get token() {
    return this._getUrlParameterByName(RouterParams.PROPERTY_TOKEN);
  }
  
  get external2bapToken() {
    return this._getUrlParameterByName(RouterParams.PROPERTY_2BAP_EXTERNAL_TOKEN);
  }
  
  get returnUrl() {
    return this._getUrlParameterByName(RouterParams.PROPERTY_RETURN_URL);
  }
  
  get hasExternalToken() {
    return Boolean(this.token) || Boolean(this.external2bapToken);
  }
  
  _decodeUrlByXml(url) {
    if (!url) return url;
    
    const escaped_one_to_xml_special_map = {
      '&amp;': '&',
      '&quot;': '"',
      '&lt;': '<',
      '&gt;': '>'
    };
    
    return url.replace(/(&quot;|&lt;|&gt;|&amp;)/g,
      function (str, item) {
        return escaped_one_to_xml_special_map[item];
      });
  }
  
  _getUrlParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    
    url = this._decodeUrlByXml(url);
    
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' ')) || '';
  }
  
}
